import { IdFile } from '../../../../models/id-file.model';

export const mapIdFileToFile = (item: IdFile): File => item.file;
